import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useContextState } from "../../context/ContextProvider";
import { removeLastItemFromBreadCrumb } from "../../utils/helperFunctions";
import Accounts from "./Accounts";
import FolderContentDetails from "./FolderContentDetails";
import FolderContents from "./FolderContents";
import FileUploader from "./FileUploader";
import Folder from "./Folders";
import { organisationPage } from "./constants";

const BASE_ROUTE = "/organizations";

const Organization = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [selectedOrgId, setSelectedOrgId] = useState(null);
  const [selectedPage, setSelectedPage] = useState(null);
  const [selectedFolderDate, setSelectedFolderDate] = useState(null);
  const [moduleName, setModuleName] = useState(null);
  const [logId, setLogId] = useState(null);

  const searchParams = new URLSearchParams(location.search);
  const platformParam = searchParams.get("platform");
  const childType = platformParam === "qbo" ? "qbo" : "xero";

  const { nestedHeader, setNestedHeader, setBreadCrumb, breadCrumb } =
    useContextState();

  useEffect(() => {
    const sp = new URLSearchParams(location.search);
    const orgId = sp.get("orgId");
    const page = sp.get("page");
    const folderDate = sp.get("folderDate");
    const module = sp.get("module");
    const log = sp.get("logId");

    setSelectedOrgId(orgId);
    setSelectedFolderDate(folderDate);
    setSelectedPage(page);
    setModuleName(module);
    setLogId(log);

    updateNestedHeaderFromURL(orgId, folderDate, module);
  }, [location]);

  const updateNestedHeaderFromURL = (orgId, folderDate, module) => {
    if (!setNestedHeader) return;

    if (orgId && folderDate && module) {
      setNestedHeader({
        header: module,
        page: organisationPage.ORGANISATION_FOLDER_CONTENTS_DETAILS,
      });
    } else if (orgId && folderDate) {
      setNestedHeader({
        header: folderDate,
        page: organisationPage.ORGANISATION_FOLDER_CONTENTS,
      });
    } else if (orgId) {
      const org = getOrgNameById(orgId);
      setNestedHeader({
        header: org || "Organization",
        page: organisationPage.ORGANISATION_FOLDER,
      });
    } else {
      setNestedHeader(null);
    }
  };

  const getOrgNameById = (id) => {
    return "Organization " + id;
  };

  const handleOrgSelection = (orgId, platform = "xero") => {
    const p = new URLSearchParams();
    p.set("orgId", orgId);
    p.set("platform", platform === "qbo" ? "qbo" : "xero");
    navigate(`${BASE_ROUTE}?${p.toString()}`);
  };

  const handleOrgSelectionForAttachment = (orgId, platform = "xero") => {
    const p = new URLSearchParams();
    p.set("orgId", orgId);
    p.set("page", "attachments");
    p.set("platform", platform === "qbo" ? "qbo" : "xero");
    navigate(`${BASE_ROUTE}?${p.toString()}`);
  };

  const handleFolderDateSelection = (date) => {
    setSelectedFolderDate(date);
    const p = new URLSearchParams(location.search);
    p.set("folderDate", date);
    p.delete("module");
    p.delete("logId");
    navigate(`${BASE_ROUTE}?${p.toString()}`);
  };

  const handleModuleSelection = (logIdParam, moduleNameParam) => {
    setModuleName(moduleNameParam);
    setLogId(logIdParam);
    const p = new URLSearchParams(location.search);
    p.set("module", moduleNameParam);
    p.set("logId", logIdParam);
    navigate(`${BASE_ROUTE}?${p.toString()}`);
  };

  const handleBack = () => {
    const p = new URLSearchParams(location.search);

    if (
      nestedHeader?.page ===
      organisationPage.ORGANISATION_FOLDER_CONTENTS_DETAILS
    ) {
      p.delete("module");
      p.delete("logId");
      navigate(`${BASE_ROUTE}?${p.toString()}`);
      setBreadCrumb(removeLastItemFromBreadCrumb(breadCrumb));
    } else if (
      nestedHeader?.page === organisationPage.ORGANISATION_FOLDER_CONTENTS
    ) {
      p.delete("folderDate");
      p.delete("module");
      p.delete("logId");
      navigate(`${BASE_ROUTE}?${p.toString()}`);
      setBreadCrumb(removeLastItemFromBreadCrumb(breadCrumb));
    } else if (nestedHeader?.page === organisationPage.ORGANISATION_FOLDER) {
      navigate(BASE_ROUTE);
      setBreadCrumb(removeLastItemFromBreadCrumb(breadCrumb));
    } else if (
      nestedHeader?.page === organisationPage.ORGANISATION_ATTACHMENTS
    ) {
      navigate(BASE_ROUTE);
      setBreadCrumb(removeLastItemFromBreadCrumb(breadCrumb));
    }
  };

  if (selectedOrgId && selectedPage && selectedPage === "attachments") {
    return selectedOrgId ? (
      <FileUploader orgId={selectedOrgId} onBack={handleBack} type={childType} />
    ) : (
      <div>Loading organization...</div>
    );
  } else if (
    nestedHeader?.page ===
      organisationPage.ORGANISATION_FOLDER_CONTENTS_DETAILS &&
    selectedOrgId &&
    selectedFolderDate &&
    moduleName
  ) {
    return (
      <FolderContentDetails
        orgId={selectedOrgId}
        date={selectedFolderDate}
        moduleName={moduleName}
        logId={logId}
        onBack={handleBack}
        type={childType}
      />
    );
  } else if (
    nestedHeader?.page === organisationPage.ORGANISATION_FOLDER_CONTENTS &&
    selectedOrgId &&
    selectedFolderDate
  ) {
    return (
      <FolderContents
        orgId={selectedOrgId}
        date={selectedFolderDate}
        onModuleEnter={handleModuleSelection}
        onBack={handleBack}
        type={childType}
      />
    );
  } else if (
    nestedHeader?.page === organisationPage.ORGANISATION_FOLDER &&
    selectedOrgId
  ) {
    return (
      <Folder
        orgId={selectedOrgId}
        onFolderEnter={handleFolderDateSelection}
        onBack={handleBack}
        onAttachmentSelected={handleOrgSelectionForAttachment}
        type={childType}
      />
    );
  } else {
    return (
      <Accounts
        type="all"
        onOrgIdChange={handleOrgSelection}
        onAttachmentSelected={handleOrgSelectionForAttachment}
      />
    );
  }
};

export default Organization;
